import React from 'react';
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IAdvancedStrategyFiltersEditorViewModel
} from "../../../services/games-filter/strategies/advanced-filter/advanced-strategy-filters-editor-view-model.interface";
import {Button} from "../../../basic-ui-components/button/base/button.component";
import {FilterLinkListComponent} from "../filter-link-list/filter-link-list.component";
import {
    IArenaGameFilterEditorViewModel
} from "../../../services/games-filter/arena-filters/arena-game-filter-editor-view-model.interface";

interface AdvancedGamesFilterComponentProps {
    filtersEditor: IAdvancedStrategyFiltersEditorViewModel;
}

@observer
export class AdvancedGamesFilterComponent extends OrbitComponent<AdvancedGamesFilterComponentProps> {

    private _onClick = async () => {
        await this.props.filtersEditor.applyFilters();
        this.services.drawer.right.back();
    }

    private _extractFilters() {
        const result: IArenaGameFilterEditorViewModel[] = [];

        this.props.filtersEditor.visibleCategories.forEach(c => {
            c.visibleFilters.forEach(f => result.push(f));
        });

        return result;
    }

    render() {
        return (
            <div>

                {this.props.filtersEditor.visibleCategories.map(c => <div key={c.title}>{c.title}</div>)}
                <FilterLinkListComponent filters={this._extractFilters()} onToggle={(filter) => filter.toggleFilter()}/>

                <Button preset="primary" onClick={this._onClick}>
                    Apply
                </Button>
                <Button preset="secondary" onClick={() => this.services.drawer.right.back()}>
                    Cancel
                </Button>
            </div>
        )
    }
}